import { createReducer, on } from '@ngrx/store';
import * as AuthActions from './auth.actions';

export interface AuthState {
  accessToken: string | null;
  isLoading: boolean;
  error: string | null;
}

export const initialState: AuthState = {
  accessToken: localStorage.getItem('access_token'),
  isLoading: false,
  error: null,
};

export const authReducer = createReducer(
  initialState,
  on(AuthActions.login, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(AuthActions.loginSuccess, (state, { response }) => {
    const accessToken =
      response.data && response.data.length > 0 && response.data[0].accessToken
        ? response.data[0].accessToken
        : null;
    return {
      ...state,
      isLoading: false,
      accessToken: accessToken || state.accessToken,
      error: null,
    };
  }),
  on(AuthActions.loginFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error,
  })),
  on(AuthActions.logout, (state) => ({
    ...state,
    accessToken: null,
  }))
);
